import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import * as dayjs from 'dayjs';
import { SubscriptionComponent } from '@liebherr/old-sage-ui';
import { AppState } from '../../../app.models';
import * as fromFirmware from '../../../firmwares';
import { Router } from '../../devices.models';

@Component({
    selector: 'liebherr-firmware-dialog',
    templateUrl: 'firmware-dialog.component.html',
    styleUrls: ['firmware-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareDialogComponent extends SubscriptionComponent {
    fwCtrl = new UntypedFormControl(undefined, Validators.required);
    firmwares: any[] = [];

    firmwares$ = this.store.select(fromFirmware.selectFirmwares);
    activeFw$ = this.store.select(fromFirmware.selectActiveFirmware);

    translations: {
        titleKey: string | null;
        hintKey: string | null;
        params: any | null;
    } = { titleKey: null, hintKey: null, params: null };

    constructor(
        private store: Store<AppState>,
        public dialogRef: MatDialogRef<FirmwareDialogComponent>,
        private translateService: TranslocoService,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: { device: Router; type: 'download' | 'activate' | 'force' }
    ) {
        super();
        this.sub.add(
            this.activeFw$.subscribe((currentFw) => {
                this.createTranslations(currentFw);
            })
        );
    }

    onCancel() {
        this.dialogRef.close(false);
    }
    onSubmit() {
        if (this.data.type === 'force') {
            if (this.fwCtrl.valid && this.fwCtrl.dirty) {
                this.dialogRef.close(this.fwCtrl.value);
            }
        } else {
            this.dialogRef.close(true);
        }
    }

    private createTranslations(currentFw?: fromFirmware.Firmware) {
        let titleKey: string | undefined;
        let hintKey: string | undefined;
        let params: any | undefined = {};
        switch (this.data.type) {
            case 'download': {
                titleKey = 'DEVICES.FW_DIALOG.DONWLOAD_TITLE';
                hintKey = 'DEVICES.FW_DIALOG.DOWNLOAD_HINT';
                params = {
                    firmware: currentFw?.version,
                    device: this.data.device.serialNumber,
                };
                break;
            }
            case 'activate': {
                titleKey = 'DEVICES.FW_DIALOG.ACTIVATE_TITLE';
                hintKey = 'DEVICES.FW_DIALOG.ACTIVATE_HINT';
                params = {
                    version: this.data.device.fwUpdateInfo?.downloadVersion || 'UNKNOWN',
                    time: dayjs(this.data.device.fwUpdateInfo?.downloadAllowedTime).format(
                        this.translateService.translate('DAYJS_DATE_FORMAT')
                    ),
                    user: this.data.device.fwUpdateInfo?.downloadAllowedBy || 'UNKNOWN',
                    device: this.data.device.serialNumber,
                };
                break;
            }
            case 'force': {
                titleKey = 'DEVICES.FW_DIALOG.FORCE_TITLE';
                break;
            }
            default: {
                break;
            }
        }

        this.translations = {
            titleKey: titleKey || null,
            hintKey: hintKey || null,
            params: params || null,
        };
    }
}
